import {post} from "./http"

export const trackEvent = event => post("https://logstash.internal.tkevents.io", event)
